import type {CheckoutPerParticipantService} from "@/scopes/checkout/domain/types";
import {produce} from "immer";

interface PerParticipantServicePayload {
  participantId: string;
  value: string;
}

export function updatePerParticipantService(payload: PerParticipantServicePayload) {
  return produce((service: CheckoutPerParticipantService) => {
    service.participants[payload.participantId].selectedValue = payload.value;
  });
}
